import { io } from "socket.io-client";

let socket = null;

const getSocketUrl = () => {
  const apiUrl = process.env.REACT_APP_ADMIN_API_URL || "http://localhost:5025/api";
  // Strip /api suffix to get the base server URL
  return apiUrl.replace(/\/api\/?$/, "");
};

export const connectSocket = (token) => {
  if (socket?.connected) return socket;

  socket = io(getSocketUrl(), {
    auth: { token },
    withCredentials: true,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 2000
  });

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => socket;
